import { Injectable } from '@angular/core';
import { BaseFormService } from '@shared/services';
import { CreateFormRules, ENTITY_TYPES, IBaseFormService } from '@shared/types';
import { createFormRules as createHawkerFormRules } from './form-rules';

@Injectable()
export class HawkerProfileFormService
  extends BaseFormService
  implements IBaseFormService<ENTITY_TYPES.HAWKER_PROFILE>
{
  public static ENTITY_TYPE: ENTITY_TYPES = ENTITY_TYPES.HAWKER_PROFILE;

  public createFormRulesFunction: CreateFormRules<HawkerProfileFormService> =
    createHawkerFormRules;
}
